import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { ButtonModule } from '../button/button.module';
import { IconModule } from '../icon/icon.module';
import { FormModule } from '../form/form.module';
import { PipesModule } from '../pipes/pipes.module';

import { DropdownMenuComponent } from './dropdown-menu/dropdown-menu.component';
import { DropdownMenuDirective } from './dropdown-menu/dropdown-menu.directive';
import { BootstrapBtnDropdownComponent } from './bootstrap-btn-dropdown/bootstrap-btn-dropdown.component';
import { SimpleDropdownComponent } from './simple-dropdown/simple-dropdown.component';
import { SquareArrowDropdownComponent } from './square-arrow-dropdown/square-arrow-dropdown.component';
import { DropdownDirective } from './dropdown.directive';
import { DropdownBtnDirective } from './dropdown-btn.directive';
import { DropdownItemDirective } from './dropdown-item.directive';
import { DropdownArrowIconDirective } from './dropdown-arrow-icon.directive';
import { PaginationDropdownComponent } from './pagination-dropdown/pagination-dropdown.component';
import { PlusDropdownComponent } from './plus-dropdown/plus-dropdown.component';
import { IconsDropdownComponent } from './icons-dropdown/icons-dropdown.component';
import { ActionsDropdownComponent } from './actions-dropdown/actions-dropdown.component';
import { SelectDropdownComponent } from './select-dropdown/select-dropdown.component';
import { SelectDropdownMenuComponent } from './select-dropdown/select-dropdown-menu/select-dropdown-menu.component';
import { ScorecardDropdownComponent } from './scorecard-dropdown/scorecard-dropdown.component';
import { AppTooltipModule } from 'shared/tooltip/tooltip.module';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    IconModule,
    FormModule,
    PipesModule,
    AppTooltipModule,
  ],
  declarations: [
    DropdownMenuComponent,
    BootstrapBtnDropdownComponent,
    DropdownDirective,
    DropdownMenuDirective,
    DropdownBtnDirective,
    DropdownItemDirective,
    PaginationDropdownComponent,
    DropdownArrowIconDirective,
    SquareArrowDropdownComponent,
    SimpleDropdownComponent,
    PlusDropdownComponent,
    IconsDropdownComponent,
    ActionsDropdownComponent,
    SelectDropdownComponent,
    SelectDropdownMenuComponent,
    ScorecardDropdownComponent,
  ],
  exports: [
    DropdownMenuComponent,
    BootstrapBtnDropdownComponent,
    DropdownDirective,
    DropdownMenuDirective,
    DropdownBtnDirective,
    DropdownItemDirective,
    PaginationDropdownComponent,
    DropdownArrowIconDirective,
    SquareArrowDropdownComponent,
    SimpleDropdownComponent,
    PlusDropdownComponent,
    IconsDropdownComponent,
    ActionsDropdownComponent,
    SelectDropdownComponent,
    SelectDropdownMenuComponent,
    ScorecardDropdownComponent,
   ],
  providers: []
})
export class DropdownModule {}
